import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RoleName } from '@/reducers/admin/allRolesReducer'
import { fetchIfNeededWrapper } from '@/reducers/fetch'
import type { HTTP_METHODS } from '@/features/admin/qa/constants'
import { adminApiAxios } from '@/api'
import { TAX_ENTITY_TYPES } from '@/features/taxes/taxConstants'

export interface SimulatedApiError {
  path: string
  httpMethod: typeof HTTP_METHODS
}

export interface Pathway {
  name: string
  description: string
  identifier: string
  simulatedApiErrors?: SimulatedApiError[]
  adminRoleName: RoleName
  taxEntities?: TAX_ENTITY_TYPES[]
}

export interface Feature {
  name: string
  linearCode: string
  description: string
  pathways: Pathway[]
  createdAt: string
}

const QAFeatureSlice = createSlice({
  name: 'qaFeature',
  initialState: null as Feature[] | null,
  reducers: {
    setQAFeatures: (state, action: PayloadAction<Feature[]>) => [
      ...(state || []),
      ...action.payload,
    ],
  },
})

export default QAFeatureSlice.reducer

export const { setQAFeatures } = QAFeatureSlice.actions

export const FETCH_QA_FEATURES_KEY = 'FETCH_QA_FEATURES_KEY'
export const fetchQAFeaturesIfNeeded = () =>
  fetchIfNeededWrapper({
    fetchKey: FETCH_QA_FEATURES_KEY,
    defaultErrorMessage: 'Error fetching all qa features',
    fetchFunction: async (dispatch) => {
      const json = await adminApiAxios.get<Feature[]>(
        '/finances/api/v1/admin/qa/features'
      )

      dispatch(setQAFeatures(json.data))
      return json.data
    },
  })
